document.addEventListener("DOMContentLoaded", async function () {
  const subscriptionCheckboxes = document.querySelectorAll(".make-monthly-order-checkbox");
  const SELLING_PLAN_ID = "3040903353";

  assignUniqueIdToSubscriptionCheckboxes();

  const makeSubscriptionAction = localStorage.getItem('make-subscription-action');
  if (makeSubscriptionAction === 'active') {
    addMonthlySubscriptionToCartProducts();
    localStorage.removeItem('make-subscription-action');
  }

  // checking if the order is a monthly order
  if (await allItemsAreMonthly() || makeSubscriptionAction === 'active') {
    updateSubscriptionCheckboxes(subscriptionCheckboxes, "check");
  }

  // making the order a monthly order
  subscriptionCheckboxes.forEach(checkbox => {
    checkbox.addEventListener("change", async function () {
      if (this.checked) {
        await addMonthlySubscriptionToCartProducts();
      } else {
        await removeMonthlySubscriptionFromCartProducts();
      }
    });
  });




  // FUNCTIONS

  function assignUniqueIdToSubscriptionCheckboxes() {
    subscriptionCheckboxes.forEach((checkbox, index) => {
      const uniqueId = "make-monthly-order-" + index;
      checkbox.setAttribute("id", uniqueId);

      const label = checkbox.closest(".make-monthly-order-label");
      label.setAttribute("for", uniqueId);
    });
  }

  async function removeMonthlySubscriptionFromCartProducts() {
    showCartLoaders();

    const cartResponse = await fetch('/cart.js');
    const cartData = await cartResponse.json();
    // console.log(cartData);

    let productItemsWithoutSubscription = [];

    for (const item of cartData.items) {
      productItemsWithoutSubscription.push({ 
        id: item.variant_id, 
        quantity: item.quantity 
      });
    }

    // Clear the cart before adding subscription items
    await fetch('/cart/clear.js', { method: 'POST' });

    // Add subscription products to the cart
    await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: productItemsWithoutSubscription })
    });

    // removeMonthlySubscriptionLabels();

    hideCartLoaders();
    updateSubscriptionCheckboxes(subscriptionCheckboxes, "uncheck");
  }

  async function addMonthlySubscriptionToCartProducts() {
    showCartLoaders();

    const cartResponse = await fetch('/cart.js');
    const cartData = await cartResponse.json();

    let subscriptionItems = [];

    for (const item of cartData.items) {
        let subscriptionVariantId = item.variant_id;

        subscriptionItems.push({
            id: subscriptionVariantId,
            quantity: item.quantity,
            selling_plan: SELLING_PLAN_ID
        });
    }

    // Clear the cart before adding subscription items
    await fetch('/cart/clear.js', { method: 'POST' });

    // Add subscription products to the cart
    await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: subscriptionItems })
    });

    // await addMonthlySubscriptionLabels();

    hideCartLoaders();
    updateSubscriptionCheckboxes(subscriptionCheckboxes, "check");
  }

  /* function removeMonthlySubscriptionLabels() {
    const itemWrappers = document.querySelectorAll(".item__wrapper");
    itemWrappers.forEach(itemWrapper => {
      itemWrapper.classList.remove("subscription");

      const monthlySubscriptionLabel = itemWrapper.querySelector(".monthly-subscription-label");
      if (monthlySubscriptionLabel) {
        monthlySubscriptionLabel.remove();
      }
    });
  }

  async function addMonthlySubscriptionLabels() {
    const cartResponseAfter = await fetch('/cart.js');
    const cartDataAfter = await cartResponseAfter.json();
    // console.log(cartDataAfter);

    cartDataAfter.items.forEach(item => {
      const itemWrapper = document.querySelector(".item__wrapper[data-id='" + item.id + "']");
      if (!itemWrapper.classList.contains("subscription")) {
        labelMonthlySubscription(item.id, itemWrapper);
      }
    });
  }

  function labelMonthlySubscription(variantId, itemWrapper) {
    const label = document.createElement("div");
    label.classList.add("monthly-subscription-label");
    label.textContent = "monthly subscription";
    itemWrapper.appendChild(label);
    itemWrapper.classList.add("subscription");
  } */

  async function allItemsAreMonthly() {
    const cartResponse = await fetch('/cart.js');
    const cartData = await cartResponse.json();

    if (cartData.items.length === 0) {
      return false;
    }
    
    return cartData.items.every(item => item.selling_plan_allocation != null);
  }

  function updateSubscriptionCheckboxes(subscriptionCheckboxes, action = "toggle") {
    subscriptionCheckboxes.forEach(checkbox => {
      if (action === "toggle") {
        checkbox.checked = !checkbox.checked;
      } else if (action === "check") {
        checkbox.checked = true;
      } else if (action === "uncheck") {
        checkbox.checked = false;
      }
    });
  }

  function showCartLoaders() {
    document.querySelector("[data-animated-cart-loader]").classList.add("show");
    document.querySelector("[data-cart-loading-spinner]").classList.add("show");
  }

  function hideCartLoaders() {
    document.querySelector("[data-animated-cart-loader]").classList.remove("show");
    document.querySelector("[data-cart-loading-spinner]").classList.remove("show");
  }
});